import React from 'react';
import { Outlet } from 'react-router-dom';

export function ListSchoolPgdQ3() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
